// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectuser{position:relative}.selu{position:absolute;top:35px;left:0;margin:0 auto;width:402px;height:360px;border-radius:4px;border:1px solid #ccc;z-index:999;background-color:#fff}.selu-body{width:400px;height:260px;border-top:1px solid #e4e4e4;border-bottom:1px solid #e4e4e4}.selu-foot{width:400px;height:50px;text-align:right;padding-right:10px;padding-top:8px}.selu-depts.scrollbar{height:221px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
